import React from "react";
import { Link, useParams } from "react-router-dom";
import PropTypes from "prop-types";

// Material
import { makeStyles } from "@material-ui/core/styles";

// Config
import { getRoute, urls } from "../../config/routes";

// Components
import Button from "../Button";

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(0, 3, 2),
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  button: {
    marginBottom: theme.spacing(3),
    width: "100%"
  }
}));

const InjuriesPlaceholder = ({ text }) => {
  const classes = useStyles();
  const { caseId } = useParams();

  return (
    <div className={classes.root}>
      <Button
        className={classes.button}
        color="primary"
        component={Link}
        disableElevation
        to={getRoute(urls.addInjury, { caseId })}
        variant="contained"
      >
        {text}
      </Button>
    </div>
  );
};

InjuriesPlaceholder.propTypes = {
  text: PropTypes.string.isRequired
};

export default InjuriesPlaceholder;
